<template>
  <v-container
    fill-height
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col cols="12">
        <material-card
            color="primary"
            class="mb-10"
        >
          <template v-slot:header>
            <div class="px-3">

              <div class="title font-weight-bold mb-2">
                Apresentação
              </div>
            </div>
          </template>

          <v-container row
              class="pa-6 ma-0"
              style="text-align: center; font-size: 130%"
          >
            <iframe md12 style="margin:-50px auto -150px auto;max-width:650px;height:740px;border:0" v-if="!authenticated" :src="urlLogin"></iframe>
            <p>
              A Central de Projetos UFMS organiza os projetos administrativos
              executados na Universidade em painéis utilizando <i>BI (Business Intelligence)</i>.
              Com essa tecnologia, o usuário consegue uma visão dinâmica dos projetos,
              a qual facilita sua análise e reorganização de acordo com a demanda de sua unidade.
            </p>
            <p>
              Na Central de Projetos, reunem-se os projetos em andamento e
              em fila para execução futura, além dos encerrados e os suspensos.
              Os projetos são reavaliados constantemente constituindo o ciclo de melhoria contínua.
              O objetivo principal da Central de Projetos é disseminar a cultura de
              Gestão de Projetos na UFMS a fim de aprimorar a cadeia de valor.
              Outrossim, a Central de Projetos contribui a fornecer transparência sobre
              as atividades administrativas executadas na UFMS.
            </p>
          </v-container>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import authService from "../services/authService";
  export default {
    components: {},
    data: () => ({
        fab: false,
        imagens: [
          require("../assets/logo-agetic-small.png"),
          require("../assets/logo-ufms.png")
        ],
        contabilidadeImg: require("../assets/contabilidade.jpg"),
        logo: require("../assets/logo.png"),

    }),
    computed: {
      urlLogin() {
        return authService.getAuthentication()
      },
      authenticated() {
        return this.$store.state.authenticated;
      }
    },
    methods: {
        onScroll(e) {
            if (typeof window === "undefined") return;
            const top = window.pageYOffset || e.target.scrollTop || 0;
            this.fab = top > 20;
        },
        toTop() {
            this.$vuetify.goTo(0);
        },
        login() {
          authService.authentication();
        },
    }
  };
  </script>
  